import { useIntl } from "react-intl";

const SelfServicePortal = () => {
    const intl = useIntl();

    const messages = {
        header: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.SelfServicePortal.header",
            defaultMessage: "Self-service portal"
        }),
        body: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.SelfServicePortal.body",
            defaultMessage:
                "Employees or customers can submit requests or search your knowledge base with an easy-to-use portal."
        })
    };
    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.body}</p>
        </>
    );
};

export default SelfServicePortal;
